import Vue from 'vue'
import Vuex from 'vuex'
import mutations from '@/pages/product/store/mutations'
import actions from '@/pages/product/store/actions'
import getters from '@/pages/product/store/getters'

import { data } from '@/pages/product/selectors'
import { getJsonData } from '@/utils/dom'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    product: {
      added_to_estimate: false,
      product_id: '',
      has_stock: true,
      first_options: [],
      second_options: [],
      sku_images: [],
      wrapping_options: [],
      color_pattern_options: [],
      sku_printable_special_colors: [],
      sku_printable_cmyk_colors: [],
      edit_pattern_options: [],
      sku_three_d_background:'',
      sku_three_d_model: {
        model_format: '',
        model_url: '',
        thumbnail_url: ''
      },
      estimate_item_id: null
    },
    estimate: {
      selected_edit_pattern: {
        id: null
      },
      selected_color_pattern: {
        id: null
      },
      wrapping_selected_option: {
        id: null
      },
      trial: false,
      printable_sku_id: null,
      color_pattern: {},
      price: 0,
      price_with_charges: 0,
      tax: 0,
      amount: 0,
      shortest_shipping_date: ''
    },
    priceTable: undefined,
    address: {
      prefecture: 'Tokyo',
      city: 'Shinagawa Ward',
      town: 'Oosaki'
    },
    imageLoading: false,
    validQuantity: true,
    isHandledProduct: true,
    requestError: {
      getProduct: false,
      addToEstimate: false
    },
    isOrderPlainProduct: false,
    serverError: null,
    productDescription: getJsonData(data.productDescription),
    productDetailMD: getJsonData(data.mdProductDetail),
    productCategoryAttributes: getJsonData(data.productCategoryAttributes),
    productAiTemplateUrl: getJsonData(data.productAiTemplateUrl),
    updatingQuantityInput: false,
    productLoading: true,
    currentSKUImageView: null,
    delivery_options: [],
    favoritesCount: getJsonData(data.commonData).favorites_count || 0,
    modalDesignOption: false,
    currentPrintColor: null
  },
  mutations,
  actions,
  getters
})
